// client/src/Home.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Container, Heading, Text, VStack, useColorMode } from "@chakra-ui/react";
import { FaSpotify } from "react-icons/fa";
import Footer from "./Components/Footer";

function Home() {
  const navigate = useNavigate();
  const { colorMode } = useColorMode();

  const handleLogin = () => {
    console.log('Environment variables:', process.env);
    const apiUrl = process.env.REACT_APP_API_URL;
    console.log('API URL:', apiUrl);
    if (!apiUrl) {
      console.error('API URL is not defined');
      return;
    }
    window.location.href = `${apiUrl}/login`;
  };

  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Container maxW="container.xl" py={12} flex="1" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <VStack spacing={8} align="center" w="100%" maxW="600px">
          <VStack spacing={4} align="center">
            <Heading
              size="2xl"
              bgGradient="linear(to-r, green.400, green.600)"
              bgClip="text"
              textAlign="center"
              lineHeight="1.2"
              fontWeight="extrabold"
              letterSpacing="tight"
            >
              PlaylistGenie
            </Heading>
            <Text
              fontSize="lg"
              color={colorMode === "light" ? "gray.600" : "gray.300"}
              textAlign="center"
              mt={4}
              maxW="500px"
              fontWeight="medium"
              letterSpacing="tight"
            >
              AI-powered playlists from your Spotify library
            </Text>
            <Text
              fontSize="md"
              color={colorMode === "light" ? "gray.500" : "gray.400"}
              textAlign="center"
              maxW="500px"
            >
              Create personalized playlists using AI. Describe your mood, activity, or vibe, and let our AI curate the perfect playlist for you.
            </Text>
          </VStack>

          <Button
            leftIcon={<FaSpotify />}
            colorScheme="green"
            size="lg"
            onClick={handleLogin}
            w="100%"
            maxW="300px"
          >
            Login with Spotify
          </Button>
        </VStack>
      </Container>
      <Footer />
    </Box>
  );
}

export default Home;
